module.exports = __webpack_public_path__ + "static/img/8.a6cf184.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/8.png
// module id = zwaz
// module chunks = 5